import {
  formatTimestampAsDate, getDateAfterDeductFromToday, getDateAtEndOfMonth, getDateAtEndOfWeek,
  getDateAtStartOfMonth,
  getDateAtStartOfWeek, getDayBeforeYesterdayDate,
  getTodayDate,
  getYesterdayDate,
} from '../../../utils/dates-utils';

export const dayBeforeYesterdaySales = (reports) => reports?.SalesLastMonth?.find((dayReport) =>
  dayReport.Datum === formatTimestampAsDate(getDayBeforeYesterdayDate()),
);

export const yesterdaySales = (reports) => reports?.SalesLastMonth?.find((dayReport) =>
  dayReport.Datum === formatTimestampAsDate(getYesterdayDate()),
);

export const todaySales = (reports) => reports?.SalesLastMonth?.find((dayReport) =>
  dayReport.Datum === formatTimestampAsDate(getTodayDate()),
);

export const thisWeekSales = (reports) => reports?.SalesLastMonth?.filter((dayReport) =>
  dayReport.Datum >= formatTimestampAsDate(getDateAtStartOfWeek(new Date())),
);

export const lastMonthSales = (reports) => reports?.SalesLastMonth?.filter((dayReport) =>
  dayReport.Datum >= formatTimestampAsDate(getDateAtStartOfMonth(getDateAfterDeductFromToday(0, 1, 0, 0))) &&
  dayReport.Datum <= formatTimestampAsDate(getDateAtEndOfMonth(getDateAfterDeductFromToday(0, 1, 0, 0))),
);

export const lastWeekSales = (reports) => reports?.SalesLastMonth?.filter((dayReport) =>
  dayReport.Datum >= formatTimestampAsDate(getDateAtStartOfWeek(getDateAfterDeductFromToday(0, 0, 1, 0))) &&
  dayReport.Datum <= formatTimestampAsDate(getDateAtEndOfWeek(getDateAfterDeductFromToday(0, 0, 1, 0))),
);

export const prevWeekSales = (reports) => reports?.SalesLastMonth?.filter((dayReport) =>
  dayReport.Datum >= formatTimestampAsDate(getDateAtStartOfWeek(getDateAfterDeductFromToday(0, 0, 2, 0))) &&
  dayReport.Datum <= formatTimestampAsDate(getDateAtEndOfWeek(getDateAfterDeductFromToday(0, 0, 2, 0))),
);

export const lastAvailable7DaysSales = (reports) => reports?.SalesLastMonth?.slice(-7);